import type * as React from 'react'

import { Popover } from '@buffer-mono/popcorn'

import type { CommentsScoreResponse } from '~publish/gql/graphql'

import { useDelayedHover } from '../hooks/useDelayedHover'
import { ScoreContent } from './ScoreContent'
import styles from './CommentsScorePopover.module.css'

type CommentsScorePopoverProps = {
  children: React.ReactNode
  isOpen: boolean
  onOpenChange: (open: boolean) => void
  commentsScore: CommentsScoreResponse
}

export const CommentsScorePopover = ({
  children,
  isOpen,
  onOpenChange,
  commentsScore,
}: CommentsScorePopoverProps): JSX.Element => {
  const { handleMouseEnter, handleMouseLeave } = useDelayedHover({
    onOpen: () => onOpenChange(true),
    onClose: () => onOpenChange(false),
    isOpen,
    openDelayDuration: 200,
  })

  return (
    <Popover defaultOpen open={isOpen} onOpenChange={onOpenChange}>
      <Popover.Trigger
        onMouseEnter={handleMouseEnter}
        onMouseLeave={handleMouseLeave}
      >
        {children}
      </Popover.Trigger>
      <Popover.Content
        side="bottom"
        align="start"
        className={styles.popoverContent}
        onMouseEnter={handleMouseEnter}
        onMouseLeave={handleMouseLeave}
        arrow
      >
        <ScoreContent commentsScore={commentsScore} />
      </Popover.Content>
    </Popover>
  )
}
